import React, { Component } from 'react';
import PropTypes from 'prop-types';
import FeaturedCategoriesList from './components/FeaturedCategoriesList';
import CategoryGrid from './components/CategoryGrid';


class ShopByCategory extends Component {
  static getDomId() {
    return 'homepage_shop_by_category';
  }

  static getComponentData() {
    const componentData = window.seMarketplace[this.getDomId()];

    if (!componentData) {
      return null;
    }

    return {
      featuredCategories: componentData.slice(0, 3),
      remainingCategories: componentData.slice(3),
    };
  }

  render() {
    const {
      featuredCategories,
      remainingCategories,
    } = this.props;

    if (featuredCategories.length === 0) {
      return '';
    }

    return (
      <div className="se-tier">
        <div className="se-container">
          <h2 className="homepage-categories__title">Shop by Category</h2>
          <div className="homepage-categories__list">
            <FeaturedCategoriesList categories={featuredCategories} />
          </div>
          <div className="homepage-categories__list">
            <CategoryGrid categories={remainingCategories} />
          </div>
        </div>
      </div>
    );
  }
}

ShopByCategory.propTypes = {
  featuredCategories: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  remainingCategories: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
};

export default ShopByCategory;
